import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Modal } from 'react-bootstrap';

const ViewVendorBankDetails = ({ data, isModalOpen, setIsModalOpen }) => {
    const Columns = [
        {
            headerName: "Vendor Email",
            field: "email",
            minWidth: 150,
        },
        {
            headerName: "Vendor Mobile",
            field: "mobileNo",
            minWidth: 150,
        },
        {
            headerName: "Bank Name",
            field: "bankName",
            minWidth: 150,
        },
        {
            headerName: "Branch Name",
            field: "branchName",
            minWidth: 150,
        },
        {
            headerName: "Account number",
            field: "accountNumber",
            minWidth: 150,
        },
        {
            headerName: "IFSC Code",
            field: "ifscCode",
            minWidth: 150,
        }
    ];

    return (
        <>
            <Modal show={isModalOpen} onHide={() => setIsModalOpen(false)} backdrop="static"
                keyboard={false} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title className="fs-4  fw-bold">Vendor Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <DataGrid
                        rows={data || []}
                        columns={Columns}
                        slots={{
                            toolbar: GridToolbar,
                        }}
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

export default ViewVendorBankDetails;